import axios from 'axios'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'

export const ModalCreateCategories = ({ loadCategories }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [categoryName, setCategoryName] = useState('')
  const [description, setDescription] = useState('')
  const [color, setColor] = useState('#3182ce')
  const [isSingleEnrollment, setIsSingleEnrollment] = useState(true)

  const createCategory = async () => {
    try {
      const response = await axios.post(
        `${constants.urlLocal}categories/create`,
        {
          name: categoryName,
          description,
          color,
          isSingleEnrollment,
        }
      )
      if (response.data.ok) {
        loadCategories()
        setIsOpen(false)
        setCategoryName('')
        setDescription('')
        setColor('#3182ce')
      }
    } catch (error) {
      console.error('Error al crear la categoría', error)
    }
  }

  return (
    <>
      <button
        className="icon-btn icon-btn--primary"
        onClick={() => setIsOpen(true)}
        title="Nueva categoría"
      >
        ＋
      </button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Crear Nueva Categoría"
      >
        <div className="form-group">
          <label className="form-label">Nombre de la Categoría</label>
          <input
            className="form-input"
            placeholder="Ingrese el nombre"
            value={categoryName}
            onChange={e => setCategoryName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Descripción</label>
          <textarea
            className="form-textarea"
            placeholder="Ingrese una descripción"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Color</label>
          <input
            className="form-color"
            type="color"
            value={color}
            onChange={e => setColor(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-checkbox">
            <input
              type="checkbox"
              checked={isSingleEnrollment}
              onChange={e => setIsSingleEnrollment(e.target.checked)}
            />
            Solo una inscripción por persona
          </label>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <Button variant="ghost" onClick={() => setIsOpen(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={createCategory}>
            Crear
          </Button>
        </div>
      </Modal>
    </>
  )
}
